import { render, staticRenderFns } from "./ContactSettingsView.vue?vue&type=template&id=4fc5aec6&scoped=true"
import script from "./ContactSettingsView.vue?vue&type=script&lang=js"
export * from "./ContactSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5aec6",
  null
  
)

export default component.exports